import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PaginatedDto, PaginationParamsDto, QuizDto } from '../models';
import { PaginationParams } from '../types';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getQuizzes(value: PaginationParams): Observable<PaginatedDto> {
        return this.httpClient
            .get<QuizDto[]>('quizzes', {
                params: new PaginationParamsDto(value).params,
                observe: 'response',
            })
            .pipe(map((response) => new PaginatedDto(response)));
    }
}
